import { fg } from '@atlassian/jira-feature-gating';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import metricsOverviewQuery, {
	type main_adminPagesPerformance_Overview_Query,
} from '@atlassian/jira-relay/src/__generated__/main_adminPagesPerformance_Overview_Query.graphql';

export const metricsOverviewPageResource =
	createRelayResource<main_adminPagesPerformance_Overview_Query>({
		type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
		getQuery: (_, { tenantContext }) => ({
			parameters: metricsOverviewQuery,
			variables: {
				cloudId: tenantContext.cloudId,
				schemaMigrationEnabled: fg('site_optimiser_schema_migration'),
			},
			options: {
				fetchPolicy: 'network-only',
			},
		}),
	});
